export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = process.env.REACT_APP_CONTEST_TOKEN;

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
